import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom"

import Application from './Application.jsx';
import UnregisterEMail from './UnregisterEMail.jsx';
import UnregisterEffectMeasureEMail from './UnregisterEffectMeasureEmail.jsx';
import SavedMapView from './ProofOfDeliveryLayout/Map/SavedMapView.jsx';
import SiteNotAvailable from './SiteNotAvailable.jsx';
import { LoadingProvider } from './ProofOfDeliveryLayout/Contexts/LoadingContext';
import { ErrorProvider } from './ProofOfDeliveryLayout/Contexts/ErrorContext';


const WrappedSavedMapView = () => (
    <ErrorProvider>
        <LoadingProvider>
            <SavedMapView />
        </LoadingProvider>
    </ErrorProvider>
);


export default class ApplicationRouting extends React.Component {

    render() {
        return (
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Application />} />
                    <Route path="/unregemail/:id" element={<UnregisterEMail />} />
                    <Route path="/unregefemail/:id" element={<UnregisterEffectMeasureEMail />} />
                    <Route path="/map/:mapId" element={<WrappedSavedMapView />} />
                </Routes>
            </BrowserRouter>
        );
    }
}